var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section",class:{'is-empty': _vm.empty}},[(_vm.empty)?_c('div',{staticClass:"section-empty"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),(!_vm.empty)?_c('core-simplebar',{staticClass:"section-scroll"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }